// libs/models/src/lib/chain/chain-id.ts
var ChainId = /* @__PURE__ */ ((ChainId2) => {
  ChainId2[ChainId2["eth"] = 1] = "eth";
  ChainId2[ChainId2["bnb"] = 56] = "bnb";
  ChainId2[ChainId2["matic"] = 137] = "matic";
  ChainId2[ChainId2["op"] = 10] = "op";
  ChainId2[ChainId2["arbitrum"] = 42161] = "arbitrum";
  ChainId2[ChainId2["gnosis"] = 100] = "gnosis";
  ChainId2[ChainId2["avalanche"] = 43114] = "avalanche";
  ChainId2[ChainId2["fantom"] = 250] = "fantom";
  ChainId2[ChainId2["aurora"] = 1313161554] = "aurora";
  ChainId2[ChainId2["klaytn"] = 8217] = "klaytn";
  ChainId2[ChainId2["zkSyncEra"] = 324] = "zkSyncEra";
  return ChainId2;
})(ChainId || {});

// libs/models/src/lib/i18n/i18n-controller.ts
var Locale = /* @__PURE__ */ ((Locale2) => {
  Locale2["en"] = "en";
  Locale2["ar"] = "ar";
  Locale2["fr"] = "fr";
  Locale2["es"] = "es";
  Locale2["de"] = "de";
  return Locale2;
})(Locale || {});

// libs/models/src/lib/themes/themes.ts
var MainColors = /* @__PURE__ */ ((MainColors2) => {
  MainColors2[MainColors2["systemSync"] = 0] = "systemSync";
  MainColors2[MainColors2["dark"] = 1] = "dark";
  MainColors2[MainColors2["darkBlue"] = 2] = "darkBlue";
  MainColors2[MainColors2["light"] = 3] = "light";
  MainColors2[MainColors2["lightBlue"] = 4] = "lightBlue";
  return MainColors2;
})(MainColors || {});
var BrandColors = /* @__PURE__ */ ((BrandColors2) => {
  BrandColors2[BrandColors2["community"] = 0] = "community";
  BrandColors2[BrandColors2["random"] = 1] = "random";
  BrandColors2[BrandColors2["rainbow"] = 2] = "rainbow";
  BrandColors2[BrandColors2["orange"] = 3] = "orange";
  BrandColors2[BrandColors2["violet"] = 4] = "violet";
  return BrandColors2;
})(BrandColors || {});
export {
  BrandColors,
  ChainId,
  Locale,
  MainColors
};
//# sourceMappingURL=index.esm.js.map
